import { api } from '../api';

export async function getCompanyByUser(id) {
    try {
        const { data } = await api.get(`/company/auth?user_id=${id}`)
        return data;
    }
    catch (error) {
        return null;
    }
}

export async function getCompanyConfigByUrl(url) {
    try {
        const { data } = await api.get(`/company-config?url=${url}`)
        return data;
    }
    catch (error) {
        return null;
    }
}

export async function getUserByCompany(id) {
    try {
        const { data } = await api.get(`/company-user?company_id=${id}`)
        return data;
    }
    catch (error) {
        return null;
    }
}

export async function getUserCompanyIdUser(idUser, idCompany) {
    try {
        const { data } = await api.get(`company-user?user_id=${idUser}&company_id=${idCompany}&permissoes=S`)
        return data;
    }
    catch (error) {
        return null;
    }
}